import { render, staticRenderFns } from "./TicketsPage.vue?vue&type=template&id=22509f3f&scoped=true"
import script from "./TicketsPage.vue?vue&type=script&lang=js"
export * from "./TicketsPage.vue?vue&type=script&lang=js"
import style0 from "./TicketsPage.vue?vue&type=style&index=0&id=22509f3f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22509f3f",
  null
  
)

export default component.exports